import React, { useEffect, useState } from 'react';

import { message } from 'antd';
import { useTranslation } from 'react-i18next';

import { ApiErrorData } from 'models/ApiResponse';
import { Contact } from 'models/Contact';

import { ContactService } from 'services/ContactService';

import Layout from '../../components/Layout/Layout';
import appI18n from '../../config/i18n';
import { ContactGrid } from './components/ContactGrid';

import './ContactUs.scss';

function ContactUs() {
  const [messageApi, contextHolder] = message.useMessage();
  const [loading, setLoading] = useState(true);
  const [contacts, setContacts] = useState<Contact[]>([]);
  const { t } = useTranslation(undefined, { i18n: appI18n });

  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    const contactResponse = await ContactService.getAvailableByCurrentCompany();

    if (contactResponse.success) {
      setContacts(contactResponse.data as Contact[]);
    } else {
      const error = contactResponse.data as ApiErrorData;
      messageApi.error(
        (error.message as string) ||
          t('scenes.contact_us.scene.errors.fetch_contacts'),
        3.5
      );
    }

    setLoading(false);
  };

  return (
    <Layout breadcrumbMode="none">
      {contextHolder}
      <ContactGrid loading={loading} contacts={contacts} />
    </Layout>
  );
}

export default ContactUs;
